import React from 'react'
import styled from 'styled-components'
import { Flex } from 'ui/bend'

const ProfileImg = styled.img`
  width: 28px;
  height: 28px;
  border-radius: 50%;
  align-self: start;
`

const ProfileContainer = styled.span`
  color: #000;
  font-family: 'Proxima-Nova';
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: 0.9px;
  text-transform: uppercase;
  display: flex;
  gap: 12px;
  align-items: ${(props) => (props.isReply ? 'baseline' : 'center')};
  @media (max-width: 768px) {
    margin-bottom: 12px;
  }
`

const InitialsCircle = styled.div`
  width: 28px;
  height: 28px;
  padding: 7px;
  border-radius: 50%;
  background-color: #e0d7d1;
  color: #000;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 10px;
  text-transform: uppercase;
`

const CommentTime = styled.div`
  color: #636363;
  font-family: 'Proxima-Nova';
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px; /* 128.571% */
  letter-spacing: 0.308px;
  display: block;
  text-transform: initial;
  margin-left: 40px;
  margin-top: ${(props) => (props.isedit ? '0' : '-12px')};
  @media (max-width: 768px) {
    margin-top: ${(props) => (props.isedit ? '-12px' : '-24px')};
  }
`

// CommentAuthor Component
const CommentAuthor = ({ user, comment, mode }) => {
  const { avatar, fullName } = user

  const getInitials = (fullName) => {
    if (!fullName) return ''
    const names = fullName.trim().split(' ')
    const firstInitial = names[0]?.charAt(0).toUpperCase() || ''
    const lastInitial =
      names.length > 1 ? names[names.length - 1].charAt(0).toUpperCase() : ''
    return firstInitial + lastInitial
  }
  const initials = getInitials(fullName)

  const timeAgo = (timestamp) => {
    const now = new Date()
    const commentTime = new Date(timestamp)

    const monthName = commentTime.toLocaleString('default', { month: 'long' })
    const dayName = commentTime.getDate()
    const yearName = commentTime.getFullYear()
    const diffInSeconds = Math.floor((now - commentTime) / 1000)

    const minutes = Math.floor(diffInSeconds / 60)
    const hours = Math.floor(minutes / 60)
    const days = Math.floor(hours / 24)

    if (days > 8) {
      return `${monthName} ${dayName}, ${yearName}`
    } else if (days > 0) {
      return `${days} day${days > 1 ? 's' : ''} ago`
    } else if (hours > 0) {
      return `${hours} hour${hours > 1 ? 's' : ''} ago`
    } else if (minutes > 0) {
      return `${minutes} minute${minutes > 1 ? 's' : ''} ago`
    } else {
      return 'Just now'
    }
  }

  const relativeTime = comment?.updatedAt ? timeAgo(comment?.updatedAt) : ''
  const timeToDisplay = relativeTime ? (
    <CommentTime isedit={mode == 'edit' ? true : false}>
      {relativeTime}
    </CommentTime>
  ) : (
    ''
  )
  return (
    <>
      <ProfileContainer href='#' isReply={mode == 'reply' ? true : false}>
        {avatar ? (
          <ProfileImg src={avatar} />
        ) : (
          <InitialsCircle>{initials}</InitialsCircle>
        )}
        {mode == 'reply' ? (
          <></>
        ) : (
          <Flex flexDirection='column'>
            <div>{fullName}</div>
          </Flex>
        )}
      </ProfileContainer>
      {mode == 'reply' ? <></> : <>{timeToDisplay}</>}
    </>
  )
}

export default CommentAuthor
